import { Injectable } from "@angular/core";
import { AdminCommonHttpService } from "./admin-common-http.service";
import { lastValueFrom } from "rxjs";

@Injectable({ providedIn: 'root' })
export class RbacService {
  private role: string = '';
  private policies: Record<string, string[]> = {};

  constructor(private commonHttp: AdminCommonHttpService) { }

  async loadRolesAndPolicies(): Promise<void> {
    const permissionsResponse = await this.commonHttp.getRbacRolePermissions();

    const entry = permissionsResponse?.[0];
    if (!entry) return;

    this.role = entry.role;
    this.policies = { [entry.role]: entry.routes };

    localStorage.setItem('rbac_role', entry.role);
    localStorage.setItem('rbac_policies', JSON.stringify(this.policies));
  }

  initializeFromStorage(): void {
    this.role = localStorage.getItem('rbac_role') ?? '';
    const policiesRaw = localStorage.getItem('rbac_policies');
    this.policies = policiesRaw ? JSON.parse(policiesRaw) : {};
  }

  canAccess(route: string): boolean {
    return this.policies[this.role]?.includes(route) ?? false;
  }
}
